module.exports = __webpack_public_path__ + "img/qixi_question.c33c9e93.jpg";